import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNItem } from './cnitem';
import { SNItem } from './snitem';

export class CNServiceCodeExtra {
    public name: string;
    public type: string;
    public value?: string;
}

@RegisterItem()
export class CNServiceCode extends SNItem {

    public values: CNItem[];

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNServiceCode';
    }

    get code() {
        return this.value;
    }

    set code(aCode: string) {
        this.value = aCode;
    }

    get label() {
        return this.getProperty('label');
    }

    set label(aLabel: string) {
        this.setProperty('label', aLabel);
    }

    get extras(): CNServiceCodeExtra[] {
        let extras = [];
        if (this.getProperty('extras') !== null && this.getProperty('extras').length !== 0) {
            extras = JSON.parse(this.getProperty('extras'));
        }
        return extras;
    }

    public addExtra(name: string, type?: string): CNServiceCodeExtra | boolean {
        let extras = [];
        if (this.getProperty('extras') !== null && this.getProperty('extras').length !== 0) {
            extras = JSON.parse(this.getProperty('extras'));
        }
        let exist = false;
        extras.forEach(extra => {
            if ((extra as CNServiceCodeExtra).name === name) {
                // already exist
                exist = true;
            }
        });
        if (exist) {
            return false;
        }
        const newExtra = new CNServiceCodeExtra();
        newExtra.name = name;
        newExtra.type = (type) ? type : 'string';
        extras.push(newExtra);
        this.setProperty('extras', JSON.stringify(extras));
        return newExtra;
    }

    public getExtra(extra: string): CNServiceCodeExtra {
        let extras = [];
        if (this.getProperty('extras') !== null && this.getProperty('extras').length !== 0) {
            extras = JSON.parse(this.getProperty('extras'));
        }
        let found: CNServiceCodeExtra;
        extras.forEach(anextra => {
            if ((anextra as CNServiceCodeExtra).name === extra) {
                // already exist
                found = anextra;
            }
        });
        return found;
    }

    public setExtra(extra: CNServiceCodeExtra): void {
        let extras = [];
        if (this.getProperty('extras') !== null && this.getProperty('extras').length !== 0) {
            extras = JSON.parse(this.getProperty('extras'));
        }
        const updatedExtras = [];
        extras.forEach(anextra => {
            if ((anextra as CNServiceCodeExtra).name === extra.name) {
                // replace this extra
                updatedExtras.push(extra);
            } else {
                updatedExtras.push(anextra);
            }
        });
        this.setProperty('extras', JSON.stringify(updatedExtras));
    }

    public extraValue(extra: string): string {
        const foundExtra = this.getExtra(extra);
        return (foundExtra && foundExtra.value) ? foundExtra.value : '';
    }

    public setExtraValue(extra: string, value: string): void {
        const foundExtra = this.getExtra(extra);
        if (foundExtra) {
            foundExtra.value = value;
            this.setExtra(foundExtra);
        }
    }

    /**
     * factory clone
     * @returns CNServiceCode
     */

    public clone(): any {
        return new CNServiceCode();
    }
}
